import { computed } from 'vue';

import { useDataSharePresetsStore, useSourcesStore } from '@/stores';

export type SourcesAndFields = Record<
  string,
  { fields: { id: number; display_name: string }[]; mdm_type: string }
>;

export type PresetFieldsDataMap = Record<
  number,
  { sourcesAndFields: SourcesAndFields }
>;

export function usePresetFieldsData() {
  const dataSharePresetsStore = useDataSharePresetsStore();
  const sourcesStore = useSourcesStore();

  const presetFieldsData = computed<PresetFieldsDataMap>(() => {
    if (!dataSharePresetsStore.allPresets) return {};

    const fieldsData: PresetFieldsDataMap = {};

    dataSharePresetsStore.allPresets.forEach((preset) => {
      const sourcesAndFields: SourcesAndFields = {};

      preset.source_fields.forEach((sourceField) => {
        const field = sourcesStore.getSourceFieldById(
          sourceField.source_field_id,
        );
        if (!field?.source_id || !field.id || !field.display_name) return;

        const source = sourcesStore.getSourceById(field.source_id);
        if (!source?.table || !source?.mdm_type) return;

        const tableName = source.table;
        if (!sourcesAndFields[tableName]) {
          sourcesAndFields[tableName] = {
            fields: [],
            mdm_type: source.mdm_type,
          };
        }

        sourcesAndFields[tableName].fields.push({
          id: field.id,
          display_name: field.display_name,
        });
      });

      fieldsData[preset.id] = { sourcesAndFields };
    });

    return fieldsData;
  });

  return { presetFieldsData };
}
